import ImageGrid from '../../../UI/ImageGrid/ImageGrid';
import heroBannerImage from '../../../../assets/JoinTeamPage/HeroBanner.png';
import { Grid, Typography } from '@mui/material';

const Vision = (props) => {
  return (
    <Grid data-testid='container' container spacing={6} alignItems='center' sx={{ mt: '1.5rem' }}>
      <Grid item lg={6}>
        <Typography data-testid='header' variant='h3' component='h1' sx={{ fontWeight: 'bold' }}>
          Our{' '}
          <Typography variant='h3' component='span' sx={{ color: 'secondary.main', fontWeight: 'bold' }}>
            Vision
          </Typography>
        </Typography>
        <Typography variant='body1' sx={{ my: '2rem' }}>
          To become the leading private mastermind community for founders in Singapore.
        </Typography>
      </Grid>
      <ImageGrid gridSize={6} src={heroBannerImage} alt={'Hero Banner'} maxWidth={{ maxWidth: '400px' }} />
    </Grid>
  );
};

export default Vision;
